import {
  callOnBeforeRun,
  type ChatEvent,
  ChatUiEventTypes,
  sendChatEvent,
  sendChatUiEvent,
} from '@trimble-agentic-external-npm-local/agentic-platform-sdk-iframe-typescript';
import {
  NarrowChat,
  type RunContextCallback,
} from '@trimble-agentic-internal-npm-local/agentic-chat-ui';
import { useCallback, useContext } from 'react';

import { useHostTools } from '../hooks/useHostTools';
import { EmbeddedConfigContext } from '../providers/embedded-config-provider';
import { mapDynamicToolsToRunContext } from '../utilities/toolUtils';

export const EmbeddedNarrowChat = () => {
  const context = useContext(EmbeddedConfigContext);
  const hostTools = useHostTools();

  const handleChatEvent = useCallback((event: ChatEvent) => {
    sendChatEvent(event.type, event.payload);
  }, []);

  const handleOnBeforeRun = useCallback(
    async (
      agentId: string
    ): Promise<Awaited<ReturnType<RunContextCallback>>> => {
      const dynamicRunContext = await callOnBeforeRun(
        agentId,
        context?.chatConfig.onBeforeRunTimeout
      );

      return mapDynamicToolsToRunContext(dynamicRunContext);
    },
    [context?.chatConfig.onBeforeRunTimeout]
  );

  return (
    <div className='flex h-[100dvh] w-[100dvw] min-h-0 flex-col overflow-hidden'>
      <NarrowChat
        agentId={context?.chatConfig.agentId || ''}
        recommendedAgents={context?.chatConfig.uiConfig.productAgents}
        threadId={context?.chatConfig.threadId}
        hideModelSelection={
          context?.chatConfig.uiConfig.chatInput.hideModelSelection
        }
        chatInputButtons={context?.chatConfig.uiConfig.chatInput.buttons}
        onBeforeRunCall={handleOnBeforeRun}
        onChatEvent={handleChatEvent}
        hostTools={hostTools}
        onChatInputButtonClick={buttonId => {
          sendChatUiEvent({
            type: ChatUiEventTypes.OnChatInputButtonClick,
            payload: buttonId,
          });
        }}
        onClose={() => {
          sendChatUiEvent({
            type: ChatUiEventTypes.OnClose,
            payload: undefined,
          });
        }}
      />
    </div>
  );
};
